<template>
    <div class="tw-bg-primary-100">
        <section class="tw-py-20 tw-text-center">
            <h1 class="tw-font-serif tw-text-4xl tw-text-gray-800 md:tw-text-6xl">A Nossa História</h1>
            <div class="tw-mx-auto tw-mt-6 tw-h-1 tw-w-20 tw-bg-secondary"></div>
        </section>

        <section class="tw-mx-auto tw-max-w-7xl tw-px-6 tw-py-16">
            <div class="tw-grid tw-items-center tw-gap-16 md:tw-grid-cols-2">
                <div class="tw-relative">
                    <v-img
                        src="@/assets/images/image12.png"
                        cover
                        class="tw-rounded-lg tw-shadow-2xl"
                        height="500" />
                    <div class="tw-absolute -tw-left-6 -tw-top-6 -tw-z-10 tw-h-full tw-w-full tw-rounded-lg tw-border-2 tw-border-secondary/20"></div>
                </div>

                <div>
                    <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary">Prazer, Marina</span>
                    <h2 class="tw-font-serif tw-mb-6 tw-mt-2 tw-text-3xl">Vamos criar o seu bolo de sonho?</h2>
                    <div class="tw-space-y-4 tw-text-lg tw-leading-relaxed tw-text-gray-600">
                        <p>Cada bolo é único e pensado exclusivamente para si.</p>
                        <p>Da escolha cuidadosa de ingredientes de excelência até ao último detalhe da decoração, tudo é feito com dedicação para que o seu momento de celebração seja inesquecível.</p>
                        <p>Para conseguirmos garantir a data e dedicar toda a atenção à sua encomenda, aconselhamos que nos contacte com atencedência.</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="tw-mx-auto tw-max-w-7xl tw-px-6 tw-py-16">
            <div class="tw-grid tw-items-center tw-gap-16 md:tw-grid-cols-2">
                <div>
                    <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary">Prazer, Marina</span>
                    <h2 class="tw-font-serif tw-mb-6 tw-mt-2 tw-text-3xl">Um pouquinho mais sobre mim</h2>
                    <div class="tw-space-y-4 tw-text-lg tw-leading-relaxed tw-text-gray-600">
                        <p>
                            Olá, sou a Marina! O meu forno e o meu coração moram em Pitões das Júnias! É aqui, na tranquilidade da serra, que crio cada um dos vossos bolinhos. Sou apaixonada por
                            juntar o melhor de dois mundos, a precisão e a criatividade do Cake Design com o toque rústico e acolhedor que só a nossa aldeia inspira. Mais do que fazer bolos bonitos,
                            adoro transformar as vossas ideias em memórias deliciosas.
                        </p>
                    </div>
                </div>

                <div class="tw-relative">
                    <v-img
                        src="@/assets/images/49a875d8-7db6-43b7-98da-0d58926bda7a.jpeg"
                        cover
                        class="tw-rounded-lg tw-shadow-2xl"
                        height="500" />
                    <div class="tw-absolute -tw-left-6 -tw-top-6 -tw-z-10 tw-h-full tw-w-full tw-rounded-lg tw-border-2 tw-border-secondary/20"></div>
                </div>
            </div>
        </section>

        <section class="tw-bg-primary-200 tw-py-20">
            <div class="tw-mx-auto tw-max-w-5xl tw-px-6 tw-text-center">
                <v-icon
                    color="secondary"
                    size="40"
                    class="tw-mb-6"
                    >mdi-barley</v-icon
                >
                <h2 class="tw-font-serif tw-mb-8 tw-text-3xl">Onde Tudo Começou</h2>
                <div class="tw-grid tw-gap-12 tw-text-left md:tw-grid-cols-2">
                    <p class="tw-leading-relaxed tw-text-gray-600">
                        Tudo nasceu entre as montanhas de Pitões das Júnias. Na <strong>Padaria Pitões</strong> nascida há mais de 20 anos, rodeada pelo aroma do pão acabado de sair do forno a lenha,
                        percebi que queria trazer algo novo para a nossa aldeia, mantendo a tradição da minha família.
                    </p>
                    <p class="tw-leading-relaxed tw-text-gray-600">
                        O "Segredo da Marina" foi crescendo entre experiências e sabores, até se tornar o atelier que é hoje: um espaço de criatividade onde a rusticidade Pitonesa se cruza com a
                        pastelaria moderna e delicada.
                    </p>
                </div>
            </div>
        </section>

        <section class="tw-mx-auto tw-max-w-7xl tw-px-6 tw-py-20">
            <div class="grid-cols-1 tw-grid tw-gap-12 md:tw-grid-cols-3">
                <div class="tw-text-center">
                    <h3 class="tw-font-serif tw-mb-4 tw-text-xl">Ingredientes Reais</h3>
                    <p class="tw-text-gray-500 tw-text-sm">Ovos, manteiga e fruta selecionada especialmente para si. O sabor é o mais importante.</p>
                </div>
                <div class="tw-text-center">
                    <h3 class="tw-font-serif tw-mb-4 tw-text-xl">Arte Manual</h3>
                    <p class="tw-text-gray-500 tw-text-sm">Cada laço, cada flor e cada camada são feitos à mão, com a calma que a qualidade exige.</p>
                </div>
                <div class="tw-text-center">
                    <h3 class="tw-font-serif tw-mb-4 tw-text-xl">Momentos Únicos</h3>
                    <p class="tw-text-gray-500 tw-text-sm">O nosso objetivo final é um só: ver o sorriso de quem recebe um pedaço do nosso trabalho.</p>
                </div>
            </div>
        </section>
    </div>
</template>
